export default "__VITE_ASSET__tN8WcV9Q__"